import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import { InputBase, IconButton, SxProps, Box } from '@mui/material';
import { ChangeEvent, FC, KeyboardEvent, useState } from 'react';
import { sxs } from '@utils/mui/sx';

const iconSx = {
    color: 'grey.400',
    ml: 1,
};

const searchBoxSx = {
    alignItems: 'center',
    backgroundColor: 'background.default',
    border: 1,
    borderColor: 'grey.600',
    borderRadius: 0.5,
    display: 'flex',
    flexDirection: 'row',
    height: 40,
    position: 'relative',
    width: '100%',
};

const searchInputSx = {
    border: 'none',
    fontSize: 14,
    ml: -1,
    width: '100%',
};

interface MiniSearchBoxProps {
    onSearch?: (searchTerm: string) => void;
    placeholder?: string;
    sx?: SxProps;
}

const MiniSearchBox: FC<MiniSearchBoxProps> = ({ onSearch, placeholder, sx = {} }) => {
    const [searchTerm, setSearchTerm] = useState('');

    const handleSearch = (value: string) => {
        if (onSearch) onSearch(value);
    };

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        setSearchTerm(event.target.value);
    };

    const handleKeyPress = (event: KeyboardEvent<HTMLInputElement>) => {
        if ('Enter' === event.key) {
            handleSearch(searchTerm);
        }
    };

    const handleClick = () => {
        handleSearch(searchTerm);
    };

    const handleClose = () => {
        setSearchTerm('');
        if (onSearch) {
            onSearch('');
        }
    };

    return (
        <Box sx={sxs([searchBoxSx, sx])}>
            <Box>
                <IconButton
                    data-test-id="miniSearchBarSearchIcon"
                    onClick={handleClick}
                    size="small"
                    sx={iconSx}
                >
                    <SearchIcon />
                </IconButton>
            </Box>
            <Box sx={{ width: '100%' }}>
                <InputBase
                    inputProps={{ 'aria-label': 'search', 'data-test-id': 'miniSearchBar' }}
                    onChange={handleChange}
                    onKeyPress={handleKeyPress}
                    placeholder={placeholder}
                    sx={searchInputSx}
                    value={searchTerm}
                />
            </Box>
            {searchTerm && (
                <IconButton onClick={handleClose} size="small" sx={iconSx}>
                    <CloseIcon />
                </IconButton>
            )}
        </Box>
    );
};

export default MiniSearchBox;
